import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

const ImplementationContractSchema = z.object({
  implementationContractValue: z.instanceof(HexNumber),
})

type ImplementationContractProps = z.infer<typeof ImplementationContractSchema>

export class ImplementationContract extends ValueObject<ImplementationContractProps> {
  public getValue(): HexNumber {
    return this.props.implementationContractValue
  }

  public static create(
    props: ImplementationContractProps
  ): ImplementationContract {
    const validatedProps = ImplementationContractSchema.parse(props)
    return new ImplementationContract(validatedProps)
  }
}
